import React from 'react';
import { Modal, List, Button } from 'antd';
import { useTranslation } from 'react-i18next';

const MriwkTREModal = ({ open = false, onCancel = () => null }) => {
  const { t } = useTranslation();

  const activitiesList = t('mriwk_tre_modal.list', {
    returnObjects: true,
    defaultValue: []
  });

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      centered
      title={t('mriwk_tre_modal.title')}
      width="50%"
      footer={[
        <Button key="cancel" onClick={onCancel}>
          {t('mriwk_tre_modal.actions.close')}
        </Button>
      ]}
    >
      <div style={{ maxHeight: '80vh', overflowY: 'scroll' }}>
        <List
          dataSource={activitiesList}
          renderItem={(item) => <List.Item>{item}</List.Item>}
        />
      </div>
    </Modal>
  );
};

export default MriwkTREModal;
